import { Facility, Pitch } from '@intelligent-play-v2/domain';

/*
  Every pitch that predates the dashboard was bulk inserted in a single
  transaction on 2020-01-23, so their created_at says nothing about when they
  went live - their device installation dates are up to 2.5 years earlier and
  land much closer to their first player hours. Pitches added since are created
  when they are onboarded, so created_at is the live date for those.
*/
const END_OF_BULK_INSERT = new Date('2020-01-24T00:00:00Z');

/*
  Installation dates come from installation metadata spreadsheets, where blank
  cells were exported as the Excel epoch (30/12/1899), so ignore anything from
  before we had devices in the ground.
*/
const EARLIEST_VALID_INSTALL_DATE = new Date('2010-01-01T00:00:00Z');

const getEarliestInstallDate = (pitch: Pitch): Date | null => {
  const installDates = (pitch.devices ?? [])
    .map(device =>
      device.dateOfInstall ? new Date(device.dateOfInstall).getTime() : NaN
    )
    .filter(
      time => !isNaN(time) && time >= EARLIEST_VALID_INSTALL_DATE.getTime()
    );

  return installDates.length > 0 ? new Date(Math.min(...installDates)) : null;
};

export const getPitchLiveDate = (pitch: Pitch): Date => {
  const createdAt = new Date(pitch.createdAt);

  if (createdAt >= END_OF_BULK_INSERT) {
    return createdAt;
  }

  return getEarliestInstallDate(pitch) ?? createdAt;
};

export const getFacilityLiveDate = (facility: Facility): Date => {
  const pitchLiveDates = (facility.pitches ?? []).map(pitch =>
    getPitchLiveDate(pitch).getTime()
  );

  return pitchLiveDates.length > 0
    ? new Date(Math.min(...pitchLiveDates))
    : new Date(facility.createdAt);
};
